import { debugMessage } from './debug.js';
import { logger } from './logger.js';
import { request as prebidRequest } from './prebid.js';
import { getGlobalSettings } from './settings.js';
import { refreshAds, defaultRequest } from './gpt/utils.js';

const headerBidders = {
  prebid: {
    request: prebidRequest,
    callback: () => {},
  },
};

/**
 * Get the ad request function.
 */
const getRequest = (headerBidder) => (
  headerBidders[headerBidder]?.request || defaultRequest
);

/**
 * Get the ad callback function.
 */
const getCallback = (headerBidder) => (
  headerBidders[headerBidder]?.callback || refreshAds
);

/**
 * Fill the ad slots
 */
const fillSlots = (slots, globalSettings) => {
  const slotsArray = Array.isArray(slots) ? slots : [slots];

  const defaultHeaderBidderTimeout = 1000;
  const { headerBidder, headerBidderTimeout = 0 } = globalSettings;
  let timeout = 0;

  if (headerBidder) {
    timeout = Number(headerBidderTimeout || defaultHeaderBidderTimeout);
  }

  const debugData = {
    slots,
    headerBidder,
    headerBidderTimeout,
  };

  if (Number.isNaN(timeout) || timeout < 0) {
    logger.error(new Error(
      'The "headerBidderTimeout" option is not a positive number: '
      + `received "${headerBidderTimeout}"`,
    ));
  }

  const request = getRequest(headerBidder);
  const callback = getCallback(headerBidder);

  debugMessage('Requesting bids', debugData);

  request(slotsArray);

  setTimeout(() => {
    const debugMsg = timeout
      ? `Header bidder timeout called after ${timeout}ms`
      : 'No header bidder timeout applied';

    debugMessage(debugMsg, debugData);

    callback(slotsArray, !!timeout);
  }, timeout);
};

/**
 * Request bids if header bidding is enabled, otherwise refresh right away.
 */
export const requestBids = (slots = []) => {
  let globalSettings = getGlobalSettings();
  const settingsAttempts = 10;
  const settingsAttemptTimeout = 200;

  (function fillSlotsWithSettings(remainingAttempts) {
    if (globalSettings) {
      fillSlots(slots, globalSettings);
      return;
    }

    setTimeout(() => {
      // eslint-disable-next-line no-param-reassign
      remainingAttempts -= 1;
      if (remainingAttempts <= 0) {
        globalSettings = getGlobalSettings();
        fillSlotsWithSettings(remainingAttempts);
      } else {
        debugMessage(`requestBids could not get globalSettings, aborting after ${settingsAttempts} attempts`);
      }
    }, settingsAttemptTimeout);
  }(settingsAttempts));
};
